import React, { useEffect, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { useReactToPrint } from 'react-to-print';
import { RiPrinterFill } from "react-icons/ri";
import logo from '../../assets/logo/logo.png'
import './style.css'
import getProductData from '../../../getProductData/getProductData';
import { toast } from 'react-hot-toast';
const Invoice = () => {
    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "invoice-data",
        onAfterPrint: () => toast("successfully Printed")
    })
    const [date, setDate] = useState(new Date());
    useEffect(() => {
        const timer = setInterval(() => {
            setDate(new Date());
        }, 1000);

        return () => {
            clearInterval(timer);
        };
    }, []);



    const { data, isLoading } = useQuery('offside', () => getProductData())


    if (isLoading) {
        return <h1 className='text-center...'>Loading...</h1>
    }

    const details = data?.data;
    console.log(details)

    return (
        <div className='bg-white py-20'>

            <div className="invoice_container my-10 container" ref={componentRef}>
                <div className="invoice_header">
                    <div className="logo_container">
                        <img src={logo} alt='' />
                        <span className=''>
                            <h2 className='pt-2'>
                                <a href="https://wehatbazar.com/" className='text-blue-500'>wehatbazer.com</a> <br />
                                Mohakhali, Dhaka <br />

                            </h2>
                        </span>
                    </div>
                    <div className="company_address text-right">
                        <h2>Invoice #No: {details?.id}</h2>
                        <span>Issue Date <br />
                            {date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                        </span> <br />
                        <button onClick={handlePrint} className='justify-center btn rounded-xs mt-1 items-center flex btn-primary btn-xs'>
                            <RiPrinterFill />
                            <span className='ml-1'>Print Invoice</span>
                        </button>
                    </div>
                </div>
                <div className="divider"></div>
                <div className="customer_container">
                    <div>
                        <h2>Billing To</h2>
                        <address>
                            <h4>
                                {details?.user?.name} <br />
                                {/* Email: someone@gmail.com <br /> */}
                                Phone: {details.user.phone}<br />
                                Shipping Address: {details && details?.shipping_address && details.shipping_address.split('"').join('')} <br />
                                Billing Address: {details && details?.billing_address && details.billing_address.split('"').join('')}
                            </h4>
                        </address>
                    </div>

                    <div className="in_details text-right">
                        <h1 className="in_head">Payment</h1>
                        <h4>
                            <span className='font-bold'>Invoice No:</span> {details?.id} <br />
                            <span className='font-bold'>Order Date: </span> {new Date(details?.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} <br />
                            <span className='font-bold'>Payment By: </span> <span className='font-bold'>Cash on delivery</span> <br />

                        </h4>

                    </div>
                </div>
                <div className="product_container">
                    <table className="item_table">
                        <tr>
                            <th>Sl. No.</th>
                            <th>Item</th>
                            <th>Price</th>
                            <th>Qty</th>
                            {/* <th>Discount</th> */}
                            <th>Total</th>
                        </tr>
                        {!Array.isArray(details) && details?.order_items ? details?.order_items?.map((item, index) => (
                            <tr key={item.id}>
                                <td>{index + 1}</td>
                                <td>{item.name}</td>
                                <td>{item.price}</td>
                                <td>{item.quantity}</td>
                                <td>{item.quantity * item.price}</td>
                            </tr>
                        )) : (<h4 className='text-xl text-red-500'>Sorry No Data Found</h4>)}
                        <tr>
                            <th colSpan="4">Total</th>

                            <th>{details?.total}</th>
                        </tr>
                    </table>
                </div>
                <div className="invoice_footer mt-10">
                    <div className="note">
                        <h2>Thank You</h2>
                        <p>{details?.user?.name}</p>
                        {/* <p>
                            Thank you for choosing our e-commerce platform for your purchase. Please find attached your invoice for your order.
                            If you have any questions or concerns, please don't hesitate to reach out to us. We are committed to providing you with 
                            the best possible shopping experience and look forward to serving you again soon.

                            <br />

                            Best regards, <br />
                            <a href="https://wehatbazar.com/">[wehatbazar.com]</a> 
                        </p> */}
                    </div>
                    <div className="invoice_footer_amount">
                        <table className="amount_table" cellSpacing="0">
                            <tr>
                                <td>Sub Total</td>
                                <td>: <b>{details?.sub_total}</b></td>
                            </tr>
                            <tr>
                                <td>Shipping Charge</td>
                                <td>: <b>{details?.shipping_charge}</b></td>
                            </tr>
                            <tr>
                                <td>Grand Total</td>
                                <td>: <b>{details?.total}</b></td>
                            </tr>
                            <tr>
                                <td>Paid amount</td>
                                <td>: <b>{details?.total}</b></td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Invoice;